export default __webpack_public_path__ + "static/bt-screen-android-mobile@2x-4431d010e1bbb774786af020a97e6ffb.png";